var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticClass: "tile-background", attrs: { wrap: "", "fill-height": "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "tile-content",
          attrs: {
            xs12: "",
            md8: _vm.isEdit,
            lg7: _vm.isEdit,
            xl8: _vm.isEdit,
          },
        },
        [
          _c(_vm.tileComponent, {
            tag: "v-component",
            attrs: {
              value: _vm.value,
              isFirst: _vm.isFirst,
              isLast: _vm.isLast,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit,
              expression: "isEdit",
            },
          ],
          style: {
            display: "flex",
            "justify-content": "end",
            "flex-wrap": "wrap",
          },
          attrs: {
            xs12: "",
            md4: "",
            lg5: "",
            xl4: "",
            "align-self-center": "",
          },
        },
        [
          _c(
            "EditButton",
            {
              staticClass: "edit-action-button",
              attrs: { small: "", disabled: _vm.loadingDelete },
              on: { click: _vm.onEdit },
            },
            [_vm._v("Edit")]
          ),
          _vm._v(" "),
          _c(
            "DeleteButton",
            {
              staticClass: "edit-action-button",
              attrs: { small: "", loading: _vm.loadingDelete },
              on: { click: _vm.onDelete },
            },
            [_vm._v("Delete")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "edit-action-button" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    dark: "",
                    color: "secondary",
                    disabled: _vm.isFirst || _vm.isReorderingItems,
                  },
                  on: { click: _vm.moveUp },
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_up")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    dark: "",
                    color: "secondary",
                    disabled: _vm.isLast || _vm.isReorderingItems,
                  },
                  on: { click: _vm.moveDown },
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_down")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("StaticContentFormModal", {
        ref: "formModal",
        attrs: { value: _vm.value, "tenant-name": _vm.tenantName },
      }),
      _vm._v(" "),
      _c("ConfirmationDialog2", { ref: "deleteConfirmation" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }